import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import GreenButton from '../Components/Buttons/Greenbutton';
import Icon from '../Components/Icons/Icon';
import { useAuth } from '../context/AuthContext';

function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await login(form);
      navigate(location.state?.from || (response.user.isAdmin ? '/admin' : '/products'), {
        replace: true,
      });
    } catch (submitError) {
      setError(submitError.message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <section className="page-card auth-shell">
      <span className="auth-shell__badge">
        <Icon name="eye" size={26} />
      </span>
      <h1 className="page-card__title">Welcome back</h1>
      <p className="page-card__text">Sign in to keep your cart, orders, and appointments in one place.</p>
      <form className="auth-form" onSubmit={handleSubmit}>
        <label className="auth-form__field">
          <span>Email</span>
          <input
            required
            type="email"
            value={form.email}
            onChange={(event) => {
              setForm((current) => ({ ...current, email: event.target.value }));
            }}
          />
        </label>
        <label className="auth-form__field">
          <span>Password</span>
          <input
            required
            type="password"
            value={form.password}
            onChange={(event) => {
              setForm((current) => ({ ...current, password: event.target.value }));
            }}
          />
        </label>
        {error ? <p className="products-state products-state--error">{error}</p> : null}
        <div className="auth-form__actions">
          <GreenButton
            disabled={isSubmitting}
            type="submit"
            text={isSubmitting ? 'Signing In...' : 'Login'}
          />
        </div>
      </form>
      <p className="auth-form__switch">
        Need an account? <Link to="/signup">Create one</Link>
      </p>
    </section>
  );
}

export default LoginPage;
